import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ArrayService } from '@delon/util/array'
import { environment } from '@env/environment'
import { buildMenuTree } from '@utils/common'
import { Observable, map } from 'rxjs'
const { msUrl } = environment.api
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private ownedRouters: any = []

  constructor(
    private httpClient: HttpClient,
    private arrayService: ArrayService,
  ) {}

  getOwnedRouters(): any {
    return this.ownedRouters
  }

  setOwnedRoutersWithParams(objs: any): any {
    this.ownedRouters = [...objs]
  }

  setOwnedRouters(url: any, callback: any): Observable<boolean> {
    return this.httpClient.get(`${msUrl.auth}/resources/uerRouter?isRead=true`).pipe(
      map((res) => {
        const { data } = res as any
        const tree = buildMenuTree(data, this.arrayService)
        this.ownedRouters = [...tree]
        const result = !!tree.find((item: any) => item.path == url)

        if (!result) {
          callback()
        }

        return result
      }),
    )
  }
}
